<template>
    <div class="menuBg" @click="editBench(item.basicData)">
        <h4>{{ item.basicData.name }}--{{ item.moduleName }}</h4>
        <div class="tip" style="color: #3a4370">
            <i class="el-icon-setting right-10"></i>
            <span>{{ item.basicData.remark }}</span>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import config from '@/common/config.js'
import AjaxHelper from '@/common/js/AjaxHelper'
export default {
    data() {
        return {
            sublistShow: false //子表默认隐藏
        }
    },
    props: {
        item: {
            type: Object,
            default() {
                return {}
            }
        },
        moduleID: {
            type: Number,
            default() {
                return {}
            }
        },
        brandId: {
            type: String,
            default() {
                return {}
            }
        },
        enumMark: {
            default() {
                return {}
            }
        },
        syncMode: {
            type: Number,
            default() {
                return 0
            }
        }
    },
    methods: {
        editBench(item) {
            this.$router.push({
                path: '/bench/edit',
                query: {
                    id: item.name,
                    moduleID: this.moduleID,
                    brandId: this.brandId,
                    operation: 'edit',
                    code: item.id,
                    module:
                        this.enumMark == 1001
                            ? '供应链'
                            : this.enumMark == 1002
                            ? '餐饮'
                            : this.enumMark == 1003
                            ? '会员'
                            : this.enumMark == 1004
                            ? 'Z5'
                            : this.enumMark == 1005
                            ? 'SCM8'
                            : 'SaiHu'
                }
            })
        }
    }
}
</script>
<style scoped>
.menuBg {
    background: rgb(105, 155, 200);
    background: -moz-radial-gradient(
        top left,
        ellipse cover,
        rgba(105, 155, 200, 1) 0%,
        rgba(160, 185, 216, 1) 97%
    );
    background: -webkit-gradient(
        radial,
        top left,
        0px,
        top left,
        100%,
        color-stop(0%, rgba(105, 155, 200, 1)),
        color-stop(97%, rgba(160, 185, 216, 1))
    );
    background: -webkit-radial-gradient(
        top left,
        ellipse cover,
        rgba(105, 155, 200, 1) 0%,
        rgba(160, 185, 216, 1) 97%
    );
    background: -o-radial-gradient(
        top left,
        ellipse cover,
        rgba(105, 155, 200, 1) 0%,
        rgba(160, 185, 216, 1) 97%
    );
    background: -ms-radial-gradient(
        top left,
        ellipse cover,
        rgba(105, 155, 200, 1) 0%,
        rgba(160, 185, 216, 1) 97%
    );
    background: radial-gradient(
        ellipse at top left,
        rgba(105, 155, 200, 1) 0%,
        rgba(160, 185, 216, 1) 97%
    );
    height: 130px;
    color: #d4e9fd;
}

.menuBg .upload-demo {
    text-align: center;
    padding: 0 15px 10px 15px;
}
.menuBg h4 {
    text-align: center;
    width: 100%;
    font-size: 18px;
    font-weight: 600;
    margin-top: 35px;
    display: inline-block;
    color: #d4e9fd;
}

.menuBg .tip {
    text-align: center;
    width: 100%;
    font-size: 14px;
    font-weight: 600;
    display: inline-block;
    color: #d4e9fd;
}

.menuDown {
    padding: 12px 0;
}

.menuDown i,
.menuDown strong {
    display: inline-block;
    margin-right: 10px;
    font-size: 16px;
    cursor: pointer;
}

.menuSelect ul {
    display: flex;
    flex-wrap: wrap;
}

.menuSelect ul li {
    flex-basis: 22%;
    min-width: 280px !important;
    flex-grow: 1;
    border: 1px #ebeef5 solid;
    margin: 10px;
}
.menu-up {
    padding-bottom: 10px;
}
.menu-up .el-button {
    border: none !important;
}

.loglists li {
    padding: 10px 0;
    font-size: 14px;
    color: #999999;
}

.loglists .el-tag {
    margin-right: 15px;
}
</style>
